import { ARTIFACT_LABEL } from '@jusbrasil-web/docview/core'

export const mockedDocument = {
  docId: 1,
  artifact: ARTIFACT_LABEL.MODELO_PECA,
  numComments: 3,
  publisher: {
    isViewer: true,
  },
}

export const mockedViewer = {
  pid: 0,
  thumborImage: null,
  name: 'usuario',
  user: {
    isAdmin: true,
  },
}

export const mockedComment = {
  id: 1,
  text: 'comment',
  date: 0,
  viewerUpVoted: true,
  viewerDownVoted: false,
  upVotes: 1,
  profile: {
    url: 'jusbrasil.com.br',
    fullname: 'publisher',
    thumborImage: null,
    hasProBadge: true,
    isViewer: false,
    pid: 123,
  },
  parentCommentId: 0,
  accessCondition: 'PUBLIC',
  review: null,
  replies: [
    {
      id: 2,
      text: 'reply 1',
      date: 0,
      viewerUpVoted: false,
      viewerDownVoted: false,
      upVotes: 1,
      profile: {
        url: 'jusbrasil.com.br',
        fullname: 'publisher',
        thumborImage: null,
        hasProBadge: false,
        isViewer: true,
        pid: 456,
      },
      parentCommentId: 1,
      accessCondition: 'PUBLIC',
      review: null,
    },
    {
      id: 3,
      text: 'reply 2',
      date: 0,
      viewerUpVoted: false,
      viewerDownVoted: true,
      upVotes: 1,
      profile: {
        url: 'jusbrasil.com.br',
        fullname: 'publisher',
        thumborImage: null,
        hasProBadge: true,
        isViewer: false,
        pid: 789,
      },
      parentCommentId: 1,
      accessCondition: 'PUBLIC',
      review: null,
    },
  ],
}
